@if (variant === 'home') {
  <ul class="pl-2 md:pl-4" data-testid="appointment-skeleton-home">
    @for (i of placeholders; track i) {
      <li class="flex px-3 md:px-4 py-3 rounded-lg">
        <div class="w-12 pr-4 shrink-0 border-r border-primary-container flex items-center">
          <app-skeleton width="2rem" height="1rem"></app-skeleton>
        </div>
        <div class="pl-3 md:pl-4 flex-1 flex flex-col gap-2 justify-center">
          <app-skeleton width="60%" height="1.25rem"></app-skeleton>
          <app-skeleton width="40%" height="0.875rem"></app-skeleton>
        </div>
        <div class="shrink-0 flex items-center">
          <app-skeleton width="1.25rem" height="1.25rem" rounded="full"></app-skeleton>
        </div>
      </li>
    }
  </ul>
} @else {
  <ul class="space-y-2" data-testid="appointment-skeleton-selector">
    @for (i of placeholders; track i) {
      <li class="flex p-4 rounded-lg border border-surface-container-highest">
        <div class="flex w-14 shrink-0 mr-2 border-r border-primary-container items-center">
          <app-skeleton width="2.25rem" height="1rem"></app-skeleton>
        </div>
        <div class="flex-1 min-w-0 flex flex-col gap-2 justify-center">
          <app-skeleton width="55%" height="1.25rem"></app-skeleton>
          <app-skeleton width="35%" height="0.875rem"></app-skeleton>
          <app-skeleton width="65%" height="0.875rem"></app-skeleton>
        </div>
        <div class="shrink-0 flex items-center">
          <app-skeleton width="1.25rem" height="1.25rem" rounded="full"></app-skeleton>
        </div>
      </li>
    }
  </ul>
}
